<template>
	<Transition name="slide-in">
		<div v-if="isVisible" class="overlay-panel" id="editor-preview-overlay-panel">
			<slot />
		</div>
	</Transition>
</template>

<script>
	import { mapGetters } from 'vuex'

	export default {
		name: 'OverlayPanel',
		mounted() {},
		data() {
			return {
				isVisible: false,
			}
		},
		computed: {
			...mapGetters('Global', ['showProductEditorPreview']),
		},
		watch: {
			showProductEditorPreview(newVal) {
				this.isVisible = newVal
			},
		},
	}
</script>

<style scoped>
	.overlay-panel {
		position: fixed;
		top: 50px; /* Leave 50px of space at the top */
		right: 0;
		width: 100%;
		height: calc(100% - 50px); /* Adjust height to not overlap the top */
		background-color: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(3px);
		z-index: 1000;
		padding: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.slide-in-enter-active,
	.slide-in-leave-active {
		transition: transform 0.3s ease;
	}

	.slide-in-enter {
		transform: translateX(100%);
	}

	.slide-in-leave-to {
		transform: translateX(100%);
	}
</style>
